export default class Noder {
  getNodedSubstrings() {}
  computeNodes(segStrings) {}
}
export default class Noder {
  getNodedSubstrings() {}
  computeNodes(segStrings) {}
}
